import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { useLanguage } from '../hooks/langs-hooks';
import themeOjb from './theme';

interface ChakraCustomProviderProps {
  children: React.ReactNode;
}

const ChakraCustomProvider: React.FC<ChakraCustomProviderProps> = ({
  children,
}) => {
  const { lang } = useLanguage();
  const theme = extendTheme({
    ...themeOjb,
    direction: lang.name === 'ar' ? 'rtl' : 'ltr',
  });

  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};

export default ChakraCustomProvider;
